import { cn } from "@theprelude/core";
import { CloseIcon } from "@theprelude/ds";
import { Handle, HandleProps, Position } from "@xyflow/react";

interface ConnectionIndicatorProps extends HandleProps {
  disabled: boolean;
  isConnected: boolean;
}

export const ConnectionIndicator = ({
  type,
  position,
  isConnected,
  disabled,
  className,
  ...props
}: ConnectionIndicatorProps) => (
  <Handle
    {...props}
    type={type}
    position={position}
    className={cn(
      className,
      "flex items-center justify-center border border-stroke-line bg-surface-background",
      Position.Top && "-translate-x-1/2 -translate-y-1/2",
      Position.Bottom && "-translate-x-1/2 translate-y-1/2",
      Position.Left && "-translate-x-1/2 -translate-y-1/2",
      Position.Right && "-translate-y-1/2 translate-x-1/2",
      type === "target" && "translate-x-0 opacity-0",
      isConnected ? "size-5" : "size-[6px]",
      disabled && "disabled",
    )}
    data-disabled={disabled}
  >
    {isConnected && <CloseIcon className="text-stroke-line" />}
  </Handle>
);
